import { Container, Grid, Typography } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import CustomCard from "../../../components/CustomCard/CustomCard";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import Select from "../../../components/Select/Select";
import TopBar from "../../../components/TopBar/TopBar";
import api from "../../../redux/actions/api";
import {
  checkedCallInApi,
  checkedInApi,
  getClinicDashboardData,
  updateAppointmentStatusById,
  updateCancel,
  updateCompleted,
  updateFinalize,
} from "../../../redux/reducers/clinicSlice";
import { storeHomeScreenDetails } from "../../../redux/reducers/mixedSlice";
import { AppColors } from "../../../util/AppColors";
import { canWriteModule } from "../../../util/roleModuleAccess";
import BookAnAppointment from "../../CommonScreens/BookAppointmentment/BookAnAppointment";
import MedicalHistoryView from "../ClinicPetDetails/MedicalHistory/MedicalHistoryView";
import "./Home.css";
import HomeVisit from "./HomeVisit";
// import Inpatient from "./Inpatient";
import InpatientAdmitPatient from "../../CommonScreens/AdmitPatient/InpatientAdmitPatient";
import VetBookAnAppointment from "../../CommonScreens/BookAppointmentment/VetBookAnAppointment";
import UpdatePetWeight from "../../CommonScreens/UpdatePetWeight/UpdatePetWeight";
import InpatientNew from "./InpatientNew/InpatientNew";

const initSearchValues = {
  Upcoming: "",
  "Checked-in": "",
  Consultation: "",
  Billing: "",
  Completed: "",
};
const defObj = { clinic: {}, vets: [], facilities: [], clinicHolidays: [] };

const Home = ({
  embedded = false,
  headerRow = null,
  headerActions = null,
} = {}) => {
  const dispatch = useDispatch();
  const canManageDashboard = canWriteModule("dashboard");
  const navigate = useNavigate();
  const location = useLocation();
  const clinicFacilitiesFetchedRef = useRef(false);
  const [selectedTab, setSelectedTab] = useState(
    location?.state?.selectedTab ?? "Outpatient",
  );
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [petData, setPetData] = useState(null);
  const [isReassign, setIsReassign] = useState(true);
  const [modalData, setModalData] = useState(null);
  const [updateWeightVsble, setUpdateWeightVsble] = useState(false);
  const [vets, setVets] = useState([]);
  const [vetListWithAll, setVetListWithAll] = useState([]);
  const allObj = { name: "All", value: "All", id: 1 };
  const [selectedVet, setSelectedVet] = useState(allObj);
  const [delModVisible, setDelModVisible] = useState(false);
  const [noShowModVsble, setNoShowModVsble] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [rescheduleModVsble, setRescheduleModVsble] = useState(false);
  const [followUpModVsble, setFollowUpModVsble] = useState(false);
  const [admitModVisible, setAdmitModVisible] = useState(false);
  const [assignVetModVisible, setAssignVetModVisible] = useState(false);
  const [assignVetvalues, setAssignVetValues] = useState({});
  const [searchValues, setSearchValues] = useState(initSearchValues);
  const [bookModVsble, setBookModVsble] = useState(false);
  const holidays = useSelector((state) => state?.doctor?.holidays);
  const dashboard = useSelector((state) => state.clinic.dashboard);
  const { vetAvailability, userDetails } = useSelector(
    (state) => state?.clinic,
  );
  const user = localStorage.getItem("user");
  const role = localStorage.getItem("role");
  const profile = JSON.parse(user);
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const {
    clinic: clinicDetails,
    vets: clinicVets,
    facilities,
    clinicHolidays,
  } = useMemo(() => {
    if (!mandateDataRaw) return defObj;
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        clinic: reqData?.clinic ?? {},
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
        facilities: Array.isArray(reqData?.facilities)
          ? reqData?.facilities
          : [],
        clinicHolidays: Array.isArray(reqData?.clinicHolidays)
          ? reqData?.clinicHolidays
          : [],
      };
    } catch {
      return defObj;
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    checkLocalStorageforReload();
    // getProfile(); // get and store user details
  }, []);

  useEffect(() => {
    const tab = location?.state?.selectedTab;
    if (!tab) return;

    setSelectedTab(tab);
    dispatch(
      storeHomeScreenDetails({
        selectedTab: tab,
        selectedVet: selectedVet?.value !== "All" ? selectedVet?.value : null,
      }),
    );

    // Inpatient has its own fetch — skip Outpatient/Virtual dashboard APIs
    if (tab === "Outpatient" || tab === "Virtual") {
      dispatch(getClinicDashboardData({ type: tab }));
    }
  }, [location?.state?.selectedTab]);

  useEffect(() => {
    const reqVetList = clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
    setVets(
      [
        {
          name: `${
            role === "ROLE_CLINIC" ? profile?.name : clinicDetails?.name
          } (Clinic)`,
          value: role === "ROLE_CLINIC" ? profile?.id : clinicDetails?.id,
          id: role === "ROLE_CLINIC" ? profile?.id : clinicDetails?.id,
        },
      ].concat(reqVetList),
    );
    setVetListWithAll(
      [
        allObj,
        {
          name: `${
            role === "ROLE_CLINIC" ? profile?.name : userDetails?.name
          } (Clinic)`,
          value: role === "ROLE_CLINIC" ? profile?.id : userDetails?.id,
          id: role === "ROLE_CLINIC" ? profile?.id : userDetails?.id,
        },
      ].concat(reqVetList),
    );
  }, [clinicVets]);

  useEffect(() => {
    // Refetch the dashboard data whenever the selected veterinarian changes
    if (selectedTab === "Outpatient" || selectedTab === "Virtual") {
      const reqObj = { type: selectedTab };
      if (selectedVet?.value !== "All")
        reqObj.url = `&doctorId=${selectedVet?.value}`;
      dispatch(getClinicDashboardData(reqObj));
    }
  }, [selectedVet]);

  const getAllClinicUserList = () => {
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.status === "Y")
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    return reqVetList;
  };

  const getOthersByType = (type) => {
    const reqType = type === "Grooming" ? "ROLE_GROOMER" : "ROLE_RADIOLOGY";
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.userRole === reqType)
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    return reqVetList;
  };

  const getVetList = () => {
    return clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
  };

  const checkIsVet = (apntVetId = null) => {
    if (!apntVetId) return false;
    return clinicVets?.some((li) =>
      li?.doctorId === apntVetId && li?.userType?.length > 0
        ? li?.userType?.some((ut) => ut?.name === "ROLE_DOCTOR")
        : false,
    );
  };

  const createModalOpen = (li, reAssign = false) => {
    setIsReassign(reAssign);
    setRescheduleModVsble(!rescheduleModVsble);
    setModalData(li);
  };

  const rescheduleModClose = () => {
    setIsReassign(false);
    setRescheduleModVsble(false);
    setModalData(null);
  };

  const createModalOpenFollowUp = (li) => {
    setFollowUpModVsble(!followUpModVsble);
    setModalData(li);
    setIsReassign(false);
  };

  const onCloseFollowUpMod = () => {
    setFollowUpModVsble(false);
    setRescheduleModVsble(false);
    setModalData(null);
  };

  const handleDelModClose = (li, typ) => {
    setModalData(li);
    if (typ === "Cancel") {
      setDelModVisible(!delModVisible);
      setCancelReason("");
    }
    if (typ === "Noshow") {
      setNoShowModVsble(true);
    }
  };

  const onCloseCancelMod = () => {
    setDelModVisible(false);
    setModalData(null);
    setCancelReason("");
  };

  const onCloseNoShow = () => {
    setNoShowModVsble(false);
    setModalData(null);
  };

  const onConfirmNoShow = () => {
    if (!modalData?.appoinment?.appointmentId) return;
    dispatch(
      updateAppointmentStatusById({
        appointmentId: modalData?.appoinment?.appointmentId,
        status: "noshow",
        successMsg: "No show added successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseNoShow();
        const reqObj = { type: selectedTab };
        if (selectedVet?.value !== "All")
          reqObj.url = `&doctorId=${selectedVet?.value}`;
        dispatch(getClinicDashboardData(reqObj));
      }
    });
  };

  const checkLocalStorageforReload = async () => {
    const videoCallPageReloaded = await JSON.parse(
      localStorage.getItem("videoCallPageReloaded"),
    );
    if (videoCallPageReloaded) {
      // if (videoCallPageReloaded?.state?.appoinment?.appointmentId) {
      //   dispatch(
      //     getPetsCompliantSummary(
      //       videoCallPageReloaded?.state?.appoinment?.appointmentId,
      //     ),
      //   );
      // }
      // if (videoCallPageReloaded?.state?.appointmentId) {
      //   dispatch(
      //     getPetsCompliantSummary(videoCallPageReloaded?.state?.appointmentId),
      //   );
      // } else if (videoCallPageReloaded?.state?.petId) {
      //   dispatch(getPetDetailsById(videoCallPageReloaded?.state?.petId));
      // }
      navigate(`/clinic-pet-details`, {
        state: { appointment: { appoinment: videoCallPageReloaded?.state } },
      });
      return localStorage.removeItem("videoCallPageReloaded");
    }
  };

  // const getProfile = async () => {
  //   api({ contentType: true, auth: true })
  //     .get("/user/profile")
  //     .then((res) => {
  //       localStorage.setItem("user", JSON.stringify(res?.data?.data));
  //       if (role !== "ROLE_CLINIC" && res?.data?.data?.createdBy) {
  //         dispatch(getUserDetailsByIdWoLoader(res?.data?.data?.createdBy));
  //       }
  //     });
  // };

  const navigatePetDetailsScreen = (appointment) => {
    navigate(`/clinic-pet-details`, { state: { appointment } });
  };

  const getFacilitiesByType = (type) => {
    const reqType =
      type === "Surgery"
        ? "OperationTheatre"
        : type === "Consultation" ||
            type === "Lab Tests" ||
            type === "Radiology Tests" ||
            type === "Others"
          ? "ConsultationRoom"
          : "BathBays";
    const reqVetList =
      facilities
        ?.filter((fl) => fl?.type?.toLowerCase() !== "devices")
        // ?.filter((fl) => fl?.type === reqType)
        ?.map((fl) => {
          return { name: fl?.name, value: fl?.facilityId, id: fl?.facilityId };
        }) ?? [];
    return reqVetList;
  };

  const filterAppointmentsByVet = (typ) => {
    return dashboard?.[typ]?.filter((itm) => !itm?.appoinment?.inpatient);
  };

  const filterAppointments = (data, type) =>
    data?.filter((item) => item?.appoinment?.appointmentType === type);

  const handleAdmit = (item) => {
    setModalData(item);
    setAdmitModVisible(true);
  };

  const handleSelectedTab = (tab) => {
    setSelectedTab(tab);
    //for storing details to call socket
    dispatch(
      storeHomeScreenDetails({
        selectedTab: tab,
        selectedVet: selectedVet?.value !== "All" ? selectedVet?.value : null,
      }),
    );
    if (tab === "Outpatient") {
      dispatch(getClinicDashboardData({ type: "Outpatient" }));
    }
    if (tab === "Virtual") {
      dispatch(getClinicDashboardData({ type: "Virtual" }));
    }
    setSearchValues(initSearchValues);
  };

  const handleChangeCardSearchValue = (value, type) => {
    const reqObj = { ...searchValues, [type]: value };
    setSearchValues(reqObj);
  };

  const renderSection = (
    title,
    data,
    colorClass,
    sectionType,
    checkIn,
    threedots,
  ) => {
    const filteredData = data?.filter((li) => {
      const search = searchValues?.[sectionType]?.toLowerCase();
      if (!search) return true;
      return (
        li?.appoinment?.petName?.toLowerCase()?.includes(search) ||
        li?.appoinment?.userName?.toLowerCase()?.includes(search) ||
        li?.appoinment?.doctorName?.toLowerCase()?.includes(search)
      );
    });

    return (
      <div
        className="w20Per borderRight"
        style={
          embedded
            ? {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflow: "hidden",
              }
            : undefined
        }
      >
        <div
          className="flex-row"
          style={embedded ? { height: "100%", minHeight: 0 } : undefined}
        >
          <div
            className="p10MinWid99Per "
            style={
              embedded
                ? {
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    minHeight: 0,
                  }
                : undefined
            }
          >
            <Typography
              className={`card-head-${colorClass}-color card-head-border-bottom-${colorClass} font-bold fs20`}
              sx={embedded ? { flexShrink: 0 } : undefined}
            >
              {title} ({data?.length ?? 0})
            </Typography>
            <div
              style={
                embedded
                  ? { flex: 1, minHeight: 0, overflow: "hidden" }
                  : undefined
              }
            >
              <CustomCard
                list={filteredData ?? []}
                dashboard
                sectionType={sectionType}
                onClickResch={(li) => createModalOpen(li, false)}
                onReassign={(li) => createModalOpen(li, true)}
                handleAction={(li, act) => handleAction(li, act)}
                handleCancel={(li, typ) => handleDelModClose(li, typ)}
                handleCompleted={(li) => handleCompleted(li)}
                onFollowUp={(li) => {
                  createModalOpenFollowUp(li);
                }}
                onClick={(li) => navigatePetDetailsScreen(li)}
                checkIn={checkIn}
                threedots={threedots && canManageDashboard}
                handleConsult={(li) => handleAssignVet(li)}
                handleCheckout={(li) => handleCheckout(li)}
                handleAdmit={(itm) => handleAdmit(itm)}
                searchValue={searchValues[sectionType]}
                onChangeSearchValue={handleChangeCardSearchValue}
                clinicDetails={{ billingMode: clinicDetails?.billingMode }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleAction = (li, action) => {
    if (action === "Update Weight") {
      const dataObj = li?.appoinment;
      const reqObj = {
        petId: dataObj?.petId,
        appointmentId: dataObj?.appointmentId,
        petName: dataObj?.petName,
        userName: dataObj?.userName,
        userId: dataObj?.userId,
        weight: dataObj?.weight,
      };
      setModalData(reqObj);
      return setUpdateWeightVsble(true);
    }
    const data = {
      appointmentId: li?.appoinment?.appointmentId,
      doctorId: li?.appoinment?.doctorId,
    };
    dispatch(checkedInApi(data)).then((res) => {
      if (res?.payload) {
        dispatch(getClinicDashboardData({ type: selectedTab }));
      }
    });
  };

  const handleCancel = () => {
    dispatch(
      updateCancel({
        appId: modalData?.appoinment?.appointmentId,
        reason: cancelReason,
      }),
    ).then((res) => {
      if (res?.payload) {
        setDelModVisible(false);
        setRescheduleModVsble(false);
        setCancelReason("");
        dispatch(getClinicDashboardData({ type: selectedTab }));
      }
    });
  };

  const onCloseAssignVetMod = () => {
    setAssignVetModVisible(false);
    setAssignVetValues({});
    setModalData(null);
  };

  const handleAssignVet = (li) => {
    if (
      (clinicDetails?.id === li?.appoinment?.doctorId &&
        !checkIsVet(profile?.id)) ||
      !li?.appoinment?.facilityId
    ) {
      const reqVet =
        clinicDetails?.id === li?.appoinment?.doctorId &&
        !checkIsVet(profile?.id)
          ? null
          : clinicVets?.find(
              (vl) =>
                vl?.doctorId ===
                (checkIsVet(li?.appoinment?.doctorId)
                  ? li?.appoinment?.doctorId
                  : checkIsVet(profile?.id)
                    ? profile?.id
                    : null),
            );
      setAssignVetValues({
        vet:
          clinicDetails?.id === li?.appoinment?.doctorId &&
          !checkIsVet(profile?.id)
            ? null
            : {
                name: reqVet?.name ?? li?.appoinment?.doctorName,
                value: reqVet?.doctorId ?? li?.appoinment?.doctorId,
                id: reqVet?.doctorId ?? li?.appoinment?.doctorId,
              },
        facility: li?.appoinment?.facilityId
          ? {
              name: li?.appoinment?.facility ?? "",
              value: li?.appoinment?.facilityId,
              id: li?.appoinment?.facilityId,
            }
          : null,
      });
      setModalData(li);
      setAssignVetModVisible(true);
      return;
    } else {
      handleConsult(
        li,
        checkIsVet(profile?.id) ? profile?.id : li?.appoinment?.doctorId,
        li?.appoinment?.facilityId,
        li?.appoinment?.facility,
      );
    }
  };

  const handleConsult = (
    li,
    vetId = null,
    facilityId = null,
    facilityName = null,
  ) => {
    const data = {
      appointmentId: li?.appoinment?.appointmentId,
      doctorId: vetId ?? li?.appoinment?.doctorId,
      facilityId,
      facilityName,
    };
    dispatch(checkedCallInApi(data)).then((res) => {
      if (res?.payload) {
        onCloseAssignVetMod();
        dispatch(getClinicDashboardData({ type: selectedTab }));
      }
    });
  };

  const handleCompleted = (li, action) => {
    dispatch(updateFinalize(li?.appoinment?.appointmentId)).then((res) => {
      if (res?.payload) {
        dispatch(getClinicDashboardData({ type: selectedTab }));
      }
    });
  };

  const handleCheckout = (li, action) => {
    dispatch(updateCompleted(li?.appoinment?.appointmentId)).then((res) => {
      if (res?.payload) {
        dispatch(getClinicDashboardData({ type: selectedTab }));
      }
    });
  };

  const onCloseAdmitModal = () => {
    // Admit success navigates to Inpatient — skip Outpatient/Virtual dashboard refresh
    setAdmitModVisible(false);
    setModalData(null);
  };

  const handleUploadComplete = async (url, apntId) => {
    await api({ contentType: true, auth: true })
      .get(`/appointment/${apntId}`)
      .then(async (getRes) => {
        if (getRes?.status === 200 || getRes?.status === 201) {
          if (getRes?.data?.data) {
            const reqObj = {
              appointment: {
                ...getRes?.data?.data,
              },
            };
            try {
              // await superTailsApi.post("/appointment-completed", reqObj);
              setSelectedHistory(null);
              setPetData(null);
            } catch (supErr) {
              console.log("SuperTail Api Error", supErr);
            }
          }
        }
      });
  };

  const onAssignVetChange = (name, value, errName) => {
    setAssignVetValues({
      ...assignVetvalues,
      [name]: value,
      [errName]: value?.value ? false : true,
    });
  };

  const onAssignVet = () => {
    if (!assignVetvalues?.vet?.value || !assignVetvalues?.facility?.value) {
      return setAssignVetValues({
        ...assignVetvalues,
        error: !assignVetvalues?.vet?.value,
        facilityErr: !assignVetvalues?.facility?.value,
      });
    }
    handleConsult(
      modalData,
      assignVetvalues?.vet?.value,
      assignVetvalues?.facility?.value,
      assignVetvalues?.facility?.name,
    );
  };

  const onCloseUpdateWeight = (typ) => {
    if (typ === "apiSuccess") {
      const reqObj = { type: selectedTab };
      if (selectedVet?.value !== "All")
        reqObj.url = `&doctorId=${selectedVet?.value}`;
      dispatch(getClinicDashboardData(reqObj));
    }
    setUpdateWeightVsble(false);
    setModalData(null);
  };

  const toolbarContent = (
    <div className="flex-row-between-align-center">
      <div className="flex-row-ali-cen">
        <div className="ml15">
          <CustomButton
            text="Outpatient"
            smallBtn={selectedTab === "Outpatient"}
            textBtn={selectedTab !== "Outpatient"}
            color={AppColors.gray3}
            onClick={() => handleSelectedTab("Outpatient")}
          />
        </div>
        <div className="ml15">
          <CustomButton
            text="Inpatient"
            smallBtn={selectedTab === "Inpatient"}
            textBtn={selectedTab !== "Inpatient"}
            color={AppColors.gray3}
            onClick={() => handleSelectedTab("Inpatient")}
          />
        </div>
        <div className="ml15">
          <CustomButton
            text="Virtual"
            smallBtn={selectedTab === "Virtual"}
            textBtn={selectedTab !== "Virtual"}
            color={AppColors.gray3}
            onClick={() => handleSelectedTab("Virtual")}
          />
        </div>
        <div className="ml15">
          <CustomButton
            text="Home Visit"
            smallBtn={selectedTab === "Home"}
            textBtn={selectedTab !== "Home"}
            color={AppColors.gray3}
            onClick={() => handleSelectedTab("Home")}
          />
        </div>
      </div>
      <div className="flex-row-ali-cen gap10">
        {canManageDashboard ? (
          <div>
            <CustomButton
              text="Book"
              smallBtn
              onClick={() => setBookModVsble(true)}
            />
          </div>
        ) : null}
        {headerActions}
        {role === "ROLE_CLINIC" && (
          <div className="w200Px">
            <Select
              list={vetListWithAll}
              value={selectedVet}
              handleChange={(e, value) => {
                const reqVal = value ?? allObj;
                setSelectedVet(reqVal);
                //for storing details to call socket
                dispatch(
                  storeHomeScreenDetails({
                    selectedTab,
                    selectedVet:
                      selectedVet?.value !== "All" ? reqVal?.value : null,
                  }),
                );
              }}
              search
              backgroundColor={AppColors.lightBlue2}
            />
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      <div
        style={
          embedded
            ? {
                height: "calc(100vh - 50px)",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }
            : undefined
        }
      >
        {embedded ? (
          <TopBar
            sx={{
              py: 1.5,
              alignItems: "flex-start",
              height: "auto",
              flexShrink: 0,
            }}
          >
            <Container maxWidth="xl">
              <div className="w100Per">
                {headerRow}
                <div className="mt10">{toolbarContent}</div>
              </div>
            </Container>
          </TopBar>
        ) : (
          <TopBar>
            <Container maxWidth="xl">{toolbarContent}</Container>
          </TopBar>
        )}
        <div
          className={embedded ? undefined : "mv20"}
          style={
            embedded
              ? {
                  flex: 1,
                  minHeight: 0,
                  overflow:
                    selectedTab === "Outpatient" || selectedTab === "Virtual"
                      ? "hidden"
                      : "auto",
                }
              : undefined
          }
        >
          <Container
            maxWidth="xl"
            sx={embedded ? { height: "100%", py: 1 } : undefined}
          >
            {selectedTab === "Inpatient" && (
              <InpatientNew
                setSelectedTab={setSelectedTab}
                selectedVet={selectedVet?.value}
              />
              // <Inpatient
              //   setSelectedTab={setSelectedTab}
              //   selectedVet={selectedVet?.value}
              // />
            )}
            {selectedTab === "Outpatient" && (
              <div
                className="flex-center"
                style={
                  embedded
                    ? { height: "100%", alignItems: "stretch" }
                    : undefined
                }
              >
                {renderSection(
                  "Upcoming",
                  filterAppointmentsByVet("upcomming"),
                  "orange",
                  "Upcoming",
                  true,
                  true,
                )}
                {renderSection(
                  "Checked-in",
                  filterAppointmentsByVet("checkedin"),
                  "rose",
                  "Checked-in",
                  true,
                  true,
                )}
                {renderSection(
                  "Consultation",
                  filterAppointmentsByVet("consultation"),
                  "green",
                  "Consultation",
                  true,
                  true,
                )}
                {renderSection(
                  "Billing",
                  filterAppointmentsByVet("billings"),
                  "yellow",
                  "Billing",
                  true,
                  true,
                )}
                {renderSection(
                  "Completed",
                  filterAppointmentsByVet("completed"),
                  "paleGreen",
                  "Completed",
                  true,
                  true,
                )}
              </div>
            )}
            {selectedTab === "Virtual" && (
              <div
                className="flex-center"
                style={
                  embedded
                    ? { height: "100%", alignItems: "stretch" }
                    : undefined
                }
              >
                {renderSection(
                  "Upcoming",
                  filterAppointments(
                    filterAppointmentsByVet("upcomming"),
                    "Virtual",
                  ),
                  "orange",
                  "Upcoming",
                  false,
                  false,
                )}
                {renderSection(
                  "Consultation",
                  filterAppointments(
                    filterAppointmentsByVet("consultation"),
                    "Virtual",
                  ),
                  "green",
                  "Consultation",
                  false,
                  false,
                )}
                {renderSection(
                  "Completed",
                  filterAppointments(
                    filterAppointmentsByVet("completed"),
                    "Virtual",
                  ),
                  "paleGreen",
                  "Completed",
                  false,
                  false,
                )}
              </div>
            )}
            {selectedTab === "Home" && (
              <HomeVisit
                selectedTab={selectedTab}
                selectedVet={selectedVet}
                vets={vets}
              />
            )}
          </Container>
        </div>
      </div>
      {selectedHistory ? (
        <MedicalHistoryView
          selectedHistory={selectedHistory}
          petData={petData}
          onUploadComplete={(e, apntId) => handleUploadComplete(e, apntId)}
        />
      ) : null}
      {bookModVsble ? (
        <VetBookAnAppointment
          modalVisible={bookModVsble}
          setBookModVisible={setBookModVsble}
          selectedVet={null}
        />
      ) : null}
      {followUpModVsble || rescheduleModVsble ? (
        <BookAnAppointment
          modalVisible={followUpModVsble || rescheduleModVsble}
          setBookModVisible={onCloseFollowUpMod}
          selectedPet={{
            petId: modalData?.appoinment?.petId,
            petName: modalData?.appoinment?.petName,
            petImage: modalData?.appoinment?.petImage,
            gender: modalData?.appoinment?.gender,
            breed: modalData?.appoinment?.breed,
            dob: modalData?.appoinment?.dob,
            userName: modalData?.appoinment?.userName,
            color: modalData?.appoinment?.color,
            weight: modalData?.appoinment?.weight,
            userMobile: modalData?.appoinment?.userMobile,
            mobile: modalData?.appoinment?.mobile,
          }}
          prevAppointmentId={modalData?.appoinment?.appointmentId}
          appointment={modalData?.appoinment}
          onBookModalCompleted={() => {
            dispatch(getClinicDashboardData({ type: selectedTab }));
          }}
          isEditAppointment={rescheduleModVsble}
          rescheduleOrReassignModVsble={rescheduleModVsble}
          isReassign={isReassign}
        />
      ) : null}

      {updateWeightVsble ? (
        <UpdatePetWeight
          modVsble={updateWeightVsble}
          onCloseMod={onCloseUpdateWeight}
          details={modalData}
        />
      ) : null}

      {/* <AdmitPatient
        modalVisible={admitModVisible}
        onCloseMod={onCloseAdmitModal}
        modalData={modalData}
      /> */}

      <InpatientAdmitPatient
        modalVisible={admitModVisible}
        onCloseMod={onCloseAdmitModal}
        modalData={modalData?.appoinment}
        sendToRecovery={false}
      />

      <CustomModal
        open={delModVisible}
        onClose={onCloseCancelMod}
        header="Cancel"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to cancel the appointment?
        </Typography>
        <div className="ml10 mt15">
          <CustomTextField
            label="Reason for cancellation"
            placeholder="Enter reason for cancellation (optional)"
            multiline
            rows={4}
            value={cancelReason}
            handleChange={(e) => setCancelReason(e.target.value)}
            fullWidth
          />
        </div>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton text="Yes" redBtn onClick={handleCancel} smallBtn />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={onCloseCancelMod} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={noShowModVsble}
        onClose={onCloseNoShow}
        header="No Show"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to mark the appointment as no-show?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={onConfirmNoShow}
                smallBtn
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={onCloseNoShow} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={assignVetModVisible}
        onClose={onCloseAssignVetMod}
        header={
          modalData?.appoinment?.doctorId === clinicDetails?.id &&
          !checkIsVet(profile?.id) &&
          !modalData?.appoinment?.facilityId
            ? "Select Vet and Facility"
            : !modalData?.appoinment?.facilityId
              ? "Select Facility"
              : "Select Vet"
        }
        modal
        modalWidth={30}
      >
        <div className="mh10">
          {modalData?.appoinment?.doctorId === clinicDetails?.id &&
          !checkIsVet(profile?.id) ? (
            <div>
              <Select
                list={
                  modalData?.appoinment?.serviceType === "Grooming" ||
                  modalData?.appoinment?.serviceType === "Lab Tests" ||
                  modalData?.appoinment?.serviceType === "Radiology Tests"
                    ? getOthersByType(modalData?.appoinment?.serviceType)
                    : modalData?.appoinment?.serviceType === "Others"
                      ? getAllClinicUserList()
                      : getVetList()
                }
                handleChange={(e, value) =>
                  onAssignVetChange("vet", value, "error")
                }
                name="vet"
                label="Vet Name *"
                search
                value={assignVetvalues?.vet}
                error={!!assignVetvalues?.error}
                helperText={
                  assignVetvalues?.error ? "Vet Name is required field" : ""
                }
              />
            </div>
          ) : null}
          {!modalData?.appoinment?.facilityId ? (
            <div
              className={
                modalData?.appoinment?.doctorId === clinicDetails?.id &&
                !checkIsVet(modalData?.appoinment?.doctorId) &&
                !checkIsVet(profile?.id)
                  ? "mt15"
                  : ""
              }
            >
              <Select
                list={getFacilitiesByType(modalData?.appoinment?.serviceType)}
                handleChange={(e, value) =>
                  onAssignVetChange("facility", value, "facilityErr")
                }
                name="facility"
                label="Facility *"
                search
                value={assignVetvalues?.facility}
                error={!!assignVetvalues?.facilityErr}
                helperText={
                  assignVetvalues?.facilityErr
                    ? "Facility is required field"
                    : ""
                }
              />
            </div>
          ) : null}
          <div className="flex-center mv20">
            <div>
              <CustomButton text="Save" onClick={onAssignVet} smallBtn />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default Home;
